<div class="density-controls">
    <div class="density-items">
        <span class="density-item loose"
              [class.active]="density === 'loose'"
              (click)="setDensity($event, 'loose')"
              title="loose">
            <span></span>
            <span></span>
            <span></span>
        </span>
        <span class="density-item tight"
              [class.active]="density === 'tight'"
              (click)="setDensity($event, 'tight')"
              title="tight">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </span>
    </div>
</div>
